import "../../node_modules/react-responsive/dist/react-responsive.js";
import { r } from "../../_virtual/react-responsive.js";
function t() {
  return r.exports.useMediaQuery({
    minWidth: 1200
  });
}
function u() {
  return r.exports.useMediaQuery({
    maxWidth: 1199
  });
}
function o(e) {
  return r.exports.useMediaQuery(e);
}
function p({
  children: e
}) {
  return t() ? e : null;
}
function a({
  children: e
}) {
  return u() ? e : null;
}
function l({
  children: e,
  ...n
}) {
  return o(n) ? e : null;
}
export {
  l as BreakPoint,
  p as Desktop,
  a as Mobile,
  o as useIsBreakpoint,
  u as useIsMobile
};
//# sourceMappingURL=BreakPoints.js.map
